import React from 'react'
import { useSelector } from 'react-redux'
import useInput from '../../hooks/input.hook'
import useFilter from '../../hooks/filter.hook'

import Input from '../../components/UI/Input'

import * as filterSelectors from '../../redux/selectors/filter.selectors'


function WorkerFilter() {
    const { setWorkersFilter } = useFilter()

    const filter = useSelector(filterSelectors.worker)
    const id = useInput(filter?.id, (value) => setWorkersFilter({id: value}))

    return (
        <>
            <Input input={id} placeholder='id' />
        </>
    )
}

export default WorkerFilter